export const ALERT = {
	SUCCESS_TITLE: 'Operación exitosa.',
	SUCCESS_SUBTITLE: 'La información ha sido registrada correctamente.',
	ERROR_TITLE: 'Error en la operación',
	ERROR_SUBTITLE:
		'Favor de intentar más tarde o contactar un agente de soporte.',
	ERROR_FIELDS: 'Favor de ingresar todos los campos requeridos.',
};

export const ERROR = {
	MISSING_FIELDS: 'Favor de ingresar todos los campos requeridos.',
	SOMETHING_WRONG: 'Algo salió mal. Favor de intentar de nuevo.',
	SERVER_INTERNAL: 'Error interno del servidor. Favor de intentar más tarde.',
	USERNAME_WRONG: 'Usuario o contraseña incorrectos.',
	EXISTING_ACCOUNT:
		'Parece que ya existe una cuenta con esta información. Por favor, revisa e intenta de nuevo.',
	VALID_EMAIL: 'Favor de ingresar un correo electrónico válido.',
	VALID_PASSWORD: 'Favor de ingresar una contraseña válida.',
	VALID_EMAIL_PASSWORD:
		'Favor de ingresar una contraseña y un correo electrónico válidos.',
	VALID_TERMS: 'Favor de aceptar los términos y condiciones.',
	VALID_CODE: 'Favor de ingresar un código válido.',
	VALID_LNADDRESS: 'Favor de ingresar una dirección Lightning válida.',
	SAME_PASSWORD:
		'La nueva contraseña no puede ser igual a la contraseña actual. Por favor, elige una contraseña diferente.',
	CONFIRM_PASSWORD:
		'Por favor, verifica que tu nueva contraseña coinicida con el campo de confirmación.',
	CURRENT_PASSWORD:
		'La contraseña actual es incorrecta. Por favor, inténtalo de nuevo.',
	FAILED_TRANSACTION:
		'La transacción no ha podido proceder. Favor de intentar más tarde o consultar a nuestro equipo de soporte.',
	ALREADY_TRANSACTION: 'Lo sentimos, la factura Lightning ha caducado.',
	AMOUNT_TRANSACTION:
		'Lo sentimos, el monto de la factura excede tu balance disponible para retirar. Favor de intentar con una cantidad menor.',
	NOT_FOUND_TRANSACTION:
		'Lo sentimos, no se pudo encontrar una ruta de pago Lightning. Favor de intentar con una nueva factura o consultar a nuestro equipo de soporte.',
	INVALID_INVOICE_TRANSACTION: 'Lo sentimos, la factura Lightning es inválida.',
	EXCHANGE_TRANSACTION:
		'Lo sentimos, de momento el tipo de cambio no está disponible para la divisa indicada. Favor de intentar más tarde. ',
	RECAPTCHA_UNAVAILABLE: 'El reCAPTCHA no está disponible en este momento.',
	RESEND_LIMIT:
		'Has excedido el límite de reenvíos. Por favor intenta nuevamente más tarde.',
	REQUEST_WRONG: 'Ocurrió un error mientras procesábamos tu solicitud.',
	LINK_WRONG: 'El enlace que usaste no es válido.',
	INSUFFICIENT_BALANCE: 'Balance insuficiente.',
};

export const SUCCESS = {
	EMAIL_SENT: '¡Operación exitosa! Revisa tu correo.',
	EMAIL_SENT_AGAIN: 'Un nuevo código ha sido enviado. Revisa tu correo.',
	RESET_PASSWORD: 'Contraseña restablecida exitosamente.',
	VALIDATE_CODE: 'Código validado exitosamente.',
	PROFILE_UPDATED: 'Tu perfil ha sido actualizado exitosamente.',
	PASSWORD_UPDATED: 'Tu contraseña ha sido actualizada exitosamente.',
	TRANSACTION_SUCCESS:
		'¡Enhorabuena! La transacción solicitada ha sido exitosa.',
	REWARD_SUCCESS: '¡Felicidades! Has reclamado tu recompensa exitosamente.',
	TRANSACTION_PENDING:
		'Hemos recibido tu solicitud de retiro. Se encuentra en revisión y normalmente se aprueba en menos de una hora. Te notificaremos una vez sea procesada.',
};

export const EMAIL_CONFIRMATION = {
	SENT: 'Te hemos enviado un correo de confirmación. Ábrelo y haz clic en el botón para activar tu cuenta. Si no lo encuentras, revisa tu carpeta de spam o promociones.',
	ERROR: 'Error al verificar el correo. Intenta más tarde.',
	SUCCESS:
		'¡Correo confirmado! Inicia sesión para disfrutar de los beneficios Bumbei. ¡Compra, comparte y gana cashback en Bitcoin! ',
	TOKEN: 'Token no válido o faltante.',
	AlREADY: 'El correo electrónico ya ha sido confirmado.',
};

export const WITHDRAWAL_CONFIRMATION = {
	ERROR:
		'Ocurrió un error al procesar la confirmación del retiro. Intenta más tarde.',
	SUCCESS:
		'¡Solicitud procesada exitosamente! El retiro ha sido aprobado y ejecutado.',
	REJECTED:
		'La solicitud ha sido rechazada y los fondos restaurados a la cuenta del usuario.',
	TOKEN: 'Token inválido, expirado o faltante.',
	AlREADY: 'Esta solicitud ya ha sido procesada previamente.',
};

export const SEND_BUY_LINK = {
	PRIMARY_CTA_LABEL: 'Enviar por correo',
	SECONDARY_CTA_LABEL: 'Continuar de todos modos',
	WARNING_TITLE: 'Recomendación importante',
	WARNING_SUBTITLE:
		'Algunas tiendas redirigen a su app móvil y eso impide registrar tu cashback. Para evitarlo, haz la compra desde una computadora o usa solo el navegador. ¿Qué prefieres hacer?',
	SUCCESS_TITLE: '¡Te enviamos el enlace por correo!',
	SUCCESS_SUBTITLE:
		'Para asegurar que tu compra se registre correctamente y recibas tu cashback, es mejor que la hagas desde una computadora.',
};
